import { Link, Navigate } from "react-router-dom";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { TbUserShield } from "react-icons/tb";

import { useAuth } from "@/lib/use-auth";

const HomePage = () => {
  const userRole = localStorage.getItem("userRole") as "admin" | "employee";

  const {
    data,
    // isPending,
    // isError, isPending
  } = useAuth();

  // if (isPending) {
  //   return <div>Loading...</div>;
  // }

  // Only redirect if user is authenticated AND userRole is valid
  if (data.success && userRole && (userRole === "admin" || userRole === "employee" || userRole === "superadmin" || userRole === "teamleader")) {
    return <Navigate to={`/${userRole}`} />;
  }

  return (
    <div className="h-full bg-gradient-to-r from-[#1d2235] to-[#262a3d] text-white pt-20 lg:pt-32">
      <div className="flex items-center flex-col">
        <h1 className="text-center text-2xl md:text-4xl font-semibold bg-gradient-to-b from-white to-transparent bg-clip-text text-white/70">
          Employee Management
        </h1>

        <div className="flex flex-col mt-20">
          <h3 className="text-2xl font-medium text-center">Who you are?</h3>

          <div className="flex flex-col lg:flex-row gap-5 mt-7">
            <Link
              to="/login/admin"
              className="p-5 px-10 rounded-md bg-[#20222f] transition-all border-2 border-transparent hover:border-[#f4ca8d] duration-300 flex flex-col items-center gap-2 w-[200px]"
            >
              <MdOutlineAdminPanelSettings className="w-7 h-7" />
              <span className="text-lg">Admin</span>
            </Link>

            <Link
              to="/login/employee"
              className="p-5 px-10 rounded-md bg-[#20222f] transition-all border-2 border-transparent hover:border-[#f4ca8d] duration-300 flex flex-col items-center gap-2 w-[200px]"
            >
              <TbUserShield className="w-7 h-7" />
              <span className="text-lg">Employee</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
